import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { HStack } from "@design-system/HStack/HStack";
import { WorkViewers } from "@components/presence/WorkViewers";
import { useIdCopy } from "@hooks/useIdCopy";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import styles from "./WorkClientNameCell.module.scss";

export const WorkClientNameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ClientsWorkOverviewRow, string>) => {
        const { name } = row.original;
        const rowType = row.original.rowType;

        const isWorkspace = rowType === "workspace";
        const { getCopyProps } = useIdCopy({
            label: isWorkspace ? "Workspace" : "Entity",
        });

        if (rowType === "group") {
            const { summary } = row.original;
            return (
                <span className={styles.nameText}>
                    {name}
                    {summary && (
                        <span className={styles.groupSummary}>
                            {` · ${summary}`}
                        </span>
                    )}
                </span>
            );
        }

        const copyId =
            rowType === "workspace"
                ? row.original.id.replace(/^workspace:/, "")
                : row.original.entityId;

        const nameText = (
            <span className={styles.nameText} {...getCopyProps(copyId)}>
                {name}
            </span>
        );

        if (row.original.rowType !== "work") {
            return nameText;
        }

        return (
            <HStack gap={8} align="center">
                {nameText}
                <WorkViewers
                    closeId={row.original.closeId}
                    workspaceId={row.original.workspaceId}
                />
            </HStack>
        );
    },
);

WorkClientNameCell.displayName = "WorkClientNameCell";
